import type { Capability } from '@taler/api-client'

/**
 * The `Capability` enum has no `PREPAID_*` entry. A prepaid recognition schedule is a
 * financial record like a loan - it commits the ledger to future postings - so viewing and
 * creating one both gate on the same capability loans and contacts already use, not a
 * per-feature capability the backend does not grant.
 */
export function canScheduleRecognitions(can: (capability: Capability) => boolean): boolean {
  return can('RECORDS_MANAGE')
}
